import React, { useEffect, useRef, useState } from 'react'
import './customization.view.css';
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import {
    ButtonAddHLPure,
    ButtonHLPure,
    CheckBoxHLPure,
    DataPickerHLPure,
    DialogSystemGLPure,
    GridSelectionHLPure,
    HeaderHLPure,
    InputHLPure,
    PromotionalFooterPure,
    SimpleLoading,
    TooltipHLPure,
    Traslates
} from '../../pures';
import { TrashIcon, arrowDropDown } from '../../../assets/logos/icons';
import { Link } from 'react-router-dom';


/**
 * @description Layout of the customization page where personalization happens. Users can select specific settings and changes will appear in the application.
 * @status no delete
 * @param {*} {
 *     imageFile,
 *     imageUrl,
 *     label,
 *     fileType,
 *     onImageUpload,
 *     onImageDelete,
 *     imageName,
 * 
 *     tooltipShow, //True or false to show tooltip
 *     positionTooltip, //Position tooltip (top, left, right, bottom) string
 *     titleTooltip, //Title tooltip string
 *     descriptionTooltip, //Description tooltip string
 *     subContent, //More text to tooltip description optional
 *     restContent, //More text to tooltip description optional
 *     informationIcon, // Choose the information icon true or false to custom img
 * }
 * @return {*} 
 */
const ImgInput = ({
    imageFile,
    imageUrl,
    label,
    fileType,
    onImageUpload,
    onImageDelete,
    imageName,

    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
}) => {
    const imageRef = useRef(null)
    const uploadFile = (ref) => ref.current.click();

    const deleteImageHandler = () => {
        imageRef.current.value = "";
        onImageDelete(imageName);
    }

    const src = imageFile || imageUrl;

    return (
        <div className='ImgInput'>
            <div className='ImgInput-image-container' onClick={() => uploadFile(imageRef)}>
                {src != "" &&
                    <img
                        className="ImgInput-image"
                        src={src}
                    />
                }
            </div>
            <div className='ImgInput-actions'>
                <ButtonAddHLPure
                    nameBtn={label}
                    onClickBtn={() => uploadFile(imageRef)}
                    iconAdd
                />
                {tooltipShow &&
                    <TooltipHLPure
                        positionTooltip={positionTooltip ? positionTooltip : "right"}
                        titleTooltip={titleTooltip}
                        descriptionTooltip={descriptionTooltip}
                        subContent={subContent}
                        restContent={restContent}
                        informationIcon={informationIcon}
                    />
                }
                {
                    imageFile &&
                    <img
                        src={TrashIcon}
                        alt="Elimina la imagen"
                        onClick={deleteImageHandler}
                        className='ImgInput-icon-trash'
                    />
                }
            </div>

            <input
                ref={imageRef}
                onChange={(e) => onImageUpload(e, imageName)}
                type='file'
                id='fileKey'
                accept={fileType}
                className='ImgInput-hidden-input'
            />
        </div>
    )
}


/**
 *
 * @status no delete
 * @param {*} props
 * @return {*} 
 */
const CustomCheckboxCell = props => {
    const { dataItem } = props;

    const handleChange = (e, field) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: e.target.checked
            });
        }
    };

    return <td className='customizationView-checkbox-cell'>
        <CheckBoxHLPure
            checkedState={dataItem.booleanValue}
            onChangeHandler={(e) => handleChange(e, "booleanValue")}
            labelCheckBox={dataItem.preferenceName}
        />
    </td>
};


/**
 * @status no delete
 * @param {*} props
 * @return {*} 
 */
const CustomInputEditCell = props => {
    const { dataItem } = props;
    const inputType = dataItem.type;
    const isExpanded = dataItem.isExpanded == undefined ? false : dataItem.isExpanded;
    const isDisabled = !dataItem.booleanValue;

    let initValue = "";

    if (inputType == "string") initValue = dataItem.stringValue;
    if (inputType == "number") initValue = dataItem.numberValue;
    if (inputType == "date") initValue = new Date(dataItem.dateValue);

    const [value, setValue] = useState(initValue);

    useEffect(() => {
        if (!dataItem.booleanValue) {
            setValue("");
        }
    }, [dataItem.booleanValue])

    const handleChange = (e, field) => {
        setValue(e.target.value);
        if (props.onChange) {
            let prefValue = e.target.value;
            if (inputType == "number") prefValue = +prefValue;

            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                value: prefValue
            });
        }
    };

    return (
        <td className={`customizationView-input-cell ${isExpanded ? "expanded" : ""}`}>
            <div className={`customizationView-input-wrapper ${inputType}`}>
                {inputType == "string" &&
                    <InputHLPure
                        inputActive
                        disabled={isDisabled}
                        typeInput={inputType}
                        valueInput={value}
                        handleChangeInput={(e) => handleChange(e, "stringValue")}
                    />
                }
                {inputType == "number" &&
                    <InputHLPure
                        inputActive
                        disabled={isDisabled}
                        typeInput={inputType}
                        valueInput={value}
                        handleChangeInput={(e) => handleChange(e, "numberValue")}
                        placeholder={"0"}
                    />
                }
                {inputType == "date" &&
                    <Traslates>
                        <DataPickerHLPure
                            valueDate={value}
                            handleChangeDate={(e) => handleChange(e, "dateValue")}
                            disabled={isDisabled}
                        />
                    </Traslates>
                }
            </div>
        </td>
    );
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const CustomizationView = (props) => {
    const { updatedPreferences, setPreferences, modifiedByUser, modifiedDate } = props;
    const { t } = useTranslation();

    const mobileResolution = useMediaQuery("(max-width:800px)");

    const onClickSave = () => props.onSavePreferences();

    const onItemChange = (event) => {
        const editedItemID = event.dataItem.preferenceId;
        const data = updatedPreferences.map(item => {
            if (item.preferenceId === editedItemID) {
                let updatedItem = { ...item, [event.field]: event.value }
                if (event.field == "booleanValue" && !event.value) {
                    // borrar input si se deselecciona el checkbox
                    updatedItem.stringValue = "";
                    updatedItem.numberValue = "";
                    updatedItem.dateValue = "";
                }
                return updatedItem;
            }
            return item;
        });
        setPreferences(data);
    };

    const header = (props) => {
        return <span>{props.title}</span>;
    };

    const DropdownIconCell = (props) => {
        const { dataItem } = props;
        const inputType = dataItem.type;

        const isExpanded = dataItem.isExpanded == undefined ? false : dataItem.isExpanded;

        const handleOnClick = () => {
            const data = updatedPreferences.map(item =>
                item.preferenceId === dataItem.preferenceId ? { ...item, isExpanded: !!!item.isExpanded } : item
            );
            setPreferences(data);
        }

        if (inputType == 'boolean') return <td className='customizationView-dropdown-cell'></td>;
        return (
            <td className='customizationView-dropdown-cell'>
                <button className='customizationView-dropdown-btn'
                    onClick={handleOnClick}
                >
                    <img src={arrowDropDown} className={`customizationView-dropdown-icon ${isExpanded ? "expanded" : ""}`} alt="Ver más" />
                </button>
            </td>
        );
    }

    if (props.isLoading) return <SimpleLoading />

    return (
        <>
            <div className='customizationView'>
                <Container>
                    <HeaderHLPure title={"Opciones del sistema"} />

                    <Grid item xs={12}>
                        <div className='customizationView-client-logo-input'>
                            <ImgInput
                                imageFile={props.clientLogo?.base64}
                                imageUrl={props.clientLogoUrl}
                                imageName="clientLogo"
                                label={"Cargar logo"}
                                fileType={t("reliableSignatureIdentificationDocuments.fileType")}
                                onImageUpload={props.onImageUpload}
                                onImageDelete={props.onImageDelete}

                                tooltipShow
                                informationIcon
                                titleTooltip={"Carga el logo de tu empresa"}
                                descriptionTooltip={"Al cargar el logo de tu empresa en la plataforma, este se visualizará en la parte superior de las pantallas."}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} className='customizationView-item-container'>
                        <p className='customizationView-list-title'>Personalización de Govo.Legal</p>

                        <GridSelectionHLPure
                            pageable={false}
                            take={updatedPreferences.length}
                            skip={0}
                            dataGrid={updatedPreferences}
                            onItemChange={onItemChange}

                            cellColumnOne={CustomCheckboxCell}
                            headerColumnOne={header}
                            titleRow1={""}

                            columnTwo={mobileResolution}
                            titleRow2={""}
                            widthColumnTwo={50}
                            cellColumnTwo={DropdownIconCell}
                            headerColumnTwo={header}

                            columnThree
                            titleRow3={""}
                            cellColumnThree={CustomInputEditCell}
                            headerColumnThree={header}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <div className='customizationView-item-container'>
                            {modifiedByUser && modifiedDate &&
                                <p className='customizationView-modified-by'>Modificado por {modifiedByUser} el {modifiedDate}</p>
                            }
                            <div className='customizationView-actions'>
                                <Link to='/configuration'>
                                    <ButtonHLPure
                                        nameBtn={"Salir"}
                                        onClickBtn={() => { }}
                                    />
                                </Link>
                                <ButtonHLPure
                                    primary
                                    nameBtn={"Guardar"}
                                    onClickBtn={onClickSave}
                                />
                            </div>
                        </div>
                    </Grid>

                    {/* <PromotionalFooterPure /> */}
                </Container>
            </div>
            <DialogSystemGLPure
                showLoadingRequesting={props.showLoadingRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}

                showCompletedRequesting={props.showCompletedRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}

                showWarningRequesting={props.showWarningRequesting}
                toggleWarningRequesting={props.toggleWarningRequesting}

                showErrorRequesting={props.showErrorRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                message={props.messageError}
            />
        </>
    )
}

export default CustomizationView;